



import React, {Component} from 'react';

import auth from "../session/Auth"
import "./css/navigation-bar.css"
import {NavLink} from "react-router-dom";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import GPAP_Breadcrumb from "./GPAP_Breadcrumb";
import Avatar from "@material-ui/core/Avatar";
import {connect} from "react-redux";
import NavigationMenu from "./navigation-menu/NavigationMenu";
import {navigationOptions} from "./navBar-components/navigationOptions";

class NavigationBar extends Component{

    constructor(props) {
        super(props);
        this.state = {
            keycloak: auth.user.keycloak,
            authenticated: auth.user.authenticated
        };
    }


    logout(){
      auth.user.keycloak.logout()
        .then((apiResponse) => {console.log("logout")})
        .catch(e=>{console.log(e)})
     }



     renderLoginDetails(){

        let {authorization}= this.props;
         if (authorization!== undefined && authorization.authenticated === true)
         {
             let user = authorization.tokenParsed.preferred_username;
             let welcome = user;
             return <React.Fragment>

                 <Button> <Avatar
                     style={{
                     background: "rgb(69, 117, 180)",
                     color: "white",
                     width: "30px",
                     height: "30px",
                     margin: "5px"
                     }}>{user.charAt(0).toUpperCase()}</Avatar> {welcome} </Button>
                 <Button onClick={this.logout.bind(this)}> <NavLink  exact to={"/#"}> LOGOUT </NavLink></Button>
             </React.Fragment>

         }
         else{
             let welcome = "Welcome Guest";
             return <React.Fragment>

                 <Button>{welcome} </Button>
                 <Button> <NavLink exact to={"/home"}>
                                 {/*  to={{ pathname: "/login/", state: { from: window.location.href }}}*/}
                     LOGIN </NavLink></Button>
             </React.Fragment>
         }
     }

    render() {



        let origin = window.location.origin;

        // Destructure window.config for clarity
        const { instand, static_files } = window.config;

// Conditional logo rendering
        const logoPathname = instand ? "/img/gpap_logo_official.svg" : "/img/gpap_logo.svg";
        const logoIMG = (
            <img
                src={`${static_files}${logoPathname}`}
                alt="GPAP"
                style={{ width: instand ? "200px" : "250px", float: instand ? "left" : "none" }}
            />
        );





// Conditionally rendered contact options
       const contactOptions = !instand && (
            <Grid item xs={5} style={{ textAlign: "end" }}>
                <Button href={`${origin}/gpap_doc/`}>User Guide</Button>
                <Button>
                    <NavLink exact to="/contact">Contact</NavLink>
                </Button>
                {this.renderLoginDetails()}
                <div className="navbar_links"></div>
            </Grid>
        );


        return (
            <div className="pageHeader">
                <Grid container
                      spacing={2}>
                    {navigationOptions}
                    <Grid item xs={2} style={{textAlign: "center"}}>
                        <div>
                            <a href={origin} style={{color: "black"}}>
                                {logoIMG}
                            </a>
                        </div>
                    </Grid>
                    {contactOptions}

                </Grid>
            </div>
        );
    }
}


function mapStateToProps (state) {
    if(state.authorization!==undefined)
    {
        return {authorization: state.authorization}
    }
}



export default connect(mapStateToProps,[])(NavigationBar);